module.exports = __webpack_public_path__ + "img/slika27.da72a280.jpg";